export default __webpack_public_path__ + "static/media/Winter_17.ced6a8dd.png";